import { useSyncExternalStore } from 'react';

/*
  Nova versao do app, avisada pelo service worker. Atualizacao nunca e
  automatica no meio de uma coleta: trocar a versao com a ficha aberta e a forma
  mais rapida de perder dado. O indicador de sincronizacao oferece o botao, e so
  com a fila de envio vazia.
*/

let disponivel = false;
let aplicar: ((recarregar?: boolean) => Promise<void>) | null = null;
const ouvintes = new Set<() => void>();

/** Chamado uma vez, no main.tsx, com a funcao que o registerSW devolve. */
export function registrarAtualizacao(fn: (recarregar?: boolean) => Promise<void>) {
  aplicar = fn;
}

/** onNeedRefresh do service worker. */
export function avisarNovaVersao() {
  disponivel = true;
  ouvintes.forEach((o) => o());
}

export function useNovaVersao(): boolean {
  return useSyncExternalStore(
    (o) => {
      ouvintes.add(o);
      return () => ouvintes.delete(o);
    },
    () => disponivel,
  );
}

/** Troca para a versao nova e recarrega. So chamar com a fila de envio vazia. */
export async function aplicarAtualizacao() {
  await aplicar?.(true);
}
